import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styleSheet } from "./style";
import { withStyles } from "@mui/styles";
import LoadingButton from "@mui/lab/LoadingButton";
import { useDispatch, useSelector } from "react-redux";
import ResponseAlert from "../../../components/responseAlert";
import { terminateListing } from "../../../redux/listings/listingDetail/terminateListing";
function TerminateContract(props) {
  let { open, setOpen, classes, id } = props;
  const [errorAlert, setErrorAlert] = useState({
    errorMsg: "",
    errorType: "",
    isOpen: false,
  });

  const dispatch = useDispatch();
  const terminateList = useSelector((state) => state.listings.listingDetail.terminateList);

  useEffect(() => {
    if (terminateList.success && !terminateList.isLoading && open) {
      setErrorAlert({
        errorMsg: "You have successfully terminated  this contract",
        errorType: "success",
        isOpen: true,
      });
      setOpen(false);
    } else if (!terminateList.isLoading && terminateList.errMsg) {
      setErrorAlert({
        errorMsg: JSON.stringify(terminateList.errMsg),
        errorType: "error",
        isOpen: true,
      });
    }
  }, [terminateList.success]);

  const handleCloseContract = () => {
    dispatch(terminateListing({ id: id }));
  };

  return (
    <React.Fragment>
      <Dialog
        disablePortal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogTitle className={classes.CloseContractHeading} id="alert-dialog-title">
          Withdraw Listing
        </DialogTitle>
        <DialogContent sx={{ width: "400px" }}>
          <br />
          Are you sure to terminate this listing?
          <br />
        </DialogContent>
        <DialogActions sx={{ marginBottom: "10px" }}>
          <Button
            onClick={() => setOpen(false)}
            sx={{
              color: "#000000",
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <LoadingButton
            onClick={() => handleCloseContract()}
            className={classes.saveModalButton}
            color="inherit"
            autoFocus
            loading={terminateList.isLoading}
            loadingPosition="start"
          >
            Confirm
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <ResponseAlert
        open={errorAlert.isOpen}
        setOpen={() => setErrorAlert({ errorMsg: "", errorType: "", isOpen: false })}
        alertType={errorAlert.errorType}
        alertMessage={errorAlert.errorMsg}
      />
    </React.Fragment>
  );
}

export default withStyles(styleSheet, { name: "TerminateContractStyle" })(TerminateContract);
